module.exports = __webpack_public_path__ + "6b629b0c31d87bb07883cab66488a192.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/background@3x.png
// module id = 994
// module chunks = 0